
const cner_config = {
  prod: {
    cner_base_url: 'http://peer.kiwi/',
    cner_service_url: 'https://api.peer.kiwi/service/',
    cner_hcaptcha_site_key: 'ab3e26c6-bfe4-4aa8-8cb7-1fe1e5071d83',
    cner_bg_img_class: 'bg-cn-bg-img-login'
  }, peer: {
    cner_base_url: 'http://localhost:3000/',
    cner_service_url: 'https://api.peer.kiwi/service/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }
}

export default cner_config;
